"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProcessEnvInteger = void 0;
const getProcessEnvInteger = (attributeName) => {
    let res = undefined;
    const attStr = process.env[attributeName];
    if (attStr) {
        const attNum = parseInt(attStr);
        if (!isNaN(attNum)) {
            res = attNum;
        }
    }
    return res;
};
exports.getProcessEnvInteger = getProcessEnvInteger;
